import a from "../images/a.jpg"
import b from "../images/b.jpg"
import c from "../images/c.jpg"
// import D from "../images/D.jpg"
import g from "../images/g.jpg"
import f from "../images/f.jpg"
import i from "../images/slider1.jpg"
import j from "../images/slider2.jpg"
import k from "../images/slider3.jpg"




const items = [
    {
        id: "1",
        category: "corporate",
        image: a
    },
    {
        id: "2",
        category: "monochrome",
        image: b
    },
    {
        id: "3",
        category: "Portraits",
        image: c
    },
    {
        id: "4",
        category: "wedding",
        image: a
    },
    {
        id: "5",
        category: "wildlife",
        image: c
    },
    {
        id: "6",
        category: "corporate",
        image: f
    },
    {
        id: "7",
        category: "wedding",
        image: a
    },
    {
        id: "8",
        category: "corporate",
        image: b
    },
    {
        id: "9",
        category: "corporate",
        image: f
    },
    {
        id: "10",
        category: "wildlife",
        image: g
    },
    {
        id: "11",
        category: "wedding",
        image: i
    },
    {
        id: "12",
        category: "wedding",
        image: j
    },
    {
        id: "13",
        category: "wedding",
        image: k
    },
    

]
export default items